import React from 'react';
import {
  IncentiveRatesList,
  IncentiveRatesListConfig,
} from '@scheduling/components';
import { Gutter } from '@common/components';
import { FiltersType } from '@common/hooks';

export function AdminWorkforceGroupRates({
  workforceGroupId,
  onFiltersChange,
}: {
  workforceGroupId: string;
  onFiltersChange?: (filters: FiltersType) => void;
}) {
  const localStorageFilterKey = 'AdminWorkforceGroupRates';

  const config: IncentiveRatesListConfig = {
    showWorkforceGroupColumn: false,
    filterTransform: (filters) => ({ ...filters, workforceGroup: null }),
  };

  return (
    <>
      <Gutter>
        <IncentiveRatesList
          workforceGroupId={workforceGroupId}
          onFiltersChange={onFiltersChange}
          localStorageFilterKey={localStorageFilterKey}
          config={config}
        />
      </Gutter>
    </>
  );
}
